// eslint-disable-next-line import/no-cycle
import {
  LocalRetailerConfiguration,
  ORDER_AHEAD_PROVIDER_TYPE_ALTAINE,
  ORDER_AHEAD_PROVIDER_TYPE_LULA,
  ORDER_AHEAD_PROVIDER_TYPE_OLO,
  ORDER_AHEAD_PROVIDER_TYPE_VROOM,
} from './app-config.types';

export const retailerConfigurationFallback: LocalRetailerConfiguration = {
  version: 3,
  universalLinkOrigins: [''],
  fuelGrades: {
    default: '',
    mapping: [],
    sortPrices: 'AsDefined',
  },
  appStoreURLs: {
    ios: null,
    android: null,
  },
  ios: { bundleId: 'bundle-id-placeholder' },
};

/**
 *  Updating transaction status interval (milliseconds)
 */
export const TRANSACTION_POLL_INTERVAL = 1500;
/**
 * Updating transaction status error limit
 */
export const TRANSACTION_ERROR_LIMIT = 2;
/**
 * Pin code in memory lifetime (milliseconds)
 */
export const PIN_IN_MEMORY_TTL = 3 * 60 * 1000; // 3 minutes
/**
 * Store locator: watch geolocation timeout (milliseconds)
 */
export const STORE_LOCATOR_WATCH_TIMEOUT = 15 * 1000; // 15 seconds
/**
 * Radius, which define that user is located "At The Store" (meters)
 */
export const STORE_LOCATOR_AT_THE_STORE_DISTANCE = 500;
/**
 * Maximum legal age to participate in Loyalty Program
 */
export const MEMBERSHIP_MAX_AGE = 123;

export const supportedOrderAheadProviderTypes = [
  ORDER_AHEAD_PROVIDER_TYPE_OLO,
  ORDER_AHEAD_PROVIDER_TYPE_LULA,
  ORDER_AHEAD_PROVIDER_TYPE_ALTAINE,
  ORDER_AHEAD_PROVIDER_TYPE_VROOM,
];
